export default __webpack_public_path__ + "static/media/money-bag.08912b95.svg";